var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.498 23.6724C18.0254 23.6724 18.3989 23.2183 18.6699 22.5151L23.4673 9.9834C23.5991 9.64648 23.6724 9.34619 23.6724 9.09717C23.6724 8.62109 23.3794 8.32812 22.9033 8.32812C22.6543 8.32812 22.354 8.40137 22.0171 8.5332L9.41943 13.3599C8.8042 13.5942 8.32812 13.9678 8.32812 14.5024C8.32812 15.1763 8.84082 15.4033 9.54395 15.6157L14.832 17.1685L16.3701 22.3906C16.5898 23.1304 16.8169 23.6724 17.498 23.6724ZM15.1616 16.0552L10.1079 14.5098C9.99072 14.4731 9.9541 14.4438 9.9541 14.3926C9.9541 14.3413 9.9834 14.3047 10.0933 14.2607L19.9956 10.5107C20.5815 10.291 21.1455 9.99805 21.6875 9.74902C21.2041 10.1445 20.6035 10.6133 20.2007 11.0161L15.1616 16.0552ZM17.6152 22.061C17.5566 22.061 17.5273 22.0098 17.4907 21.8926L15.9453 16.8389L20.9844 11.7998C21.3799 11.4043 21.8706 10.7891 22.2588 10.291C22.0098 10.8477 21.7095 11.4116 21.4897 12.0049L17.7397 21.9072C17.6958 22.0171 17.6665 22.061 17.6152 22.061Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Send.f4a22141de3d03d8c61f3592d4e46423.svg";